import React from "react";
import Slider from '@material-ui/lab/Slider';

class MaterialSlider extends React.Component {

    change = (e, value) => {
        this.setState({ value: +value }, () => this.props.input.onChange(+value));
    }
    render() {
        const { max, input: {value} = {} } = this.props;
        const normalizedValue = value || Math.round(max / 2);
        return (
            <React.Fragment>
                <Slider value={normalizedValue}
                        min={1}
                        max={max}
                        step={1}
                        onChange={this.change} />
            </React.Fragment>
        );
    }
}

export default MaterialSlider;



// WEBPACK FOOTER //
// ./src/components/MaterialSlider.js